<template lang="pug">
.app-popup(aria-live="polite", :aria-hidden="!activeResult")
	.app-popup__inner
		button.app-popup__close(@click.prevent="closePopup")
			i.blue-icon-close_medium
		.app-popup__content(v-if="activeResult")
			.app-popup__type(v-if="activeResult.meta.type") {{activeResult.meta.type}}
			h4.app-popup__title 
				a.app-popup__title-link(:href="activeResult.url", :target="targetBlank ? '_blank' : '_self'") {{activeResult.title}}
			.app-popup__meta(v-if="locationMarkup || activeResult.summary || activeResult.preHeader")
				.app-popup__meta-item(v-if="activeResult.meta.preHeader")
					i.app-popup__meta-icon.blue-icon-calendar_thin
					span.app-popup__meta-text(v-html="activeResult.meta.preHeader")
				.app-popup__meta-item(v-if="activeResult.summary")
					i.app-popup__meta-icon.blue-icon-clock
					span.app-popup__meta-text(v-html="activeResult.summary")
				.app-popup__meta-item(v-if="locationMarkup")
					i.app-popup__meta-icon.blue-icon-map-pin_outline_wide
					span.app-popup__meta-text(v-html="locationMarkup")
			//- .app-popup__copy(v-if="activeResult.meta.description", v-html="activeResult.meta.description")
	.app-popup__pointer
</template>
	
<script>
import sameOriginCheck from "../../../global/mixins/sameOriginCheck";

export default {
	name: "AppPopup",
	props: {
		activeResult: Object
	},
	components: {},
	data() {
		return {
			currentUrl: window.location,
			leaveTimer: null,
		};
	},
	computed: {
		isExternalLink() {
			return !sameOriginCheck(this.activeResult.url, this.currentUrl);
		},
		targetBlank() {
			return this.isExternalLink || this.config.openInNewWindow;
		},
		locationMarkup() {
			let location = this.activeResult.meta.location;
			if (!!location && this.activeResult.meta.eventLocation) {
				location += "\r\n" + this.activeResult.meta.eventLocation;
			} else if (this.activeResult.meta.eventLocation) {
				location = this.activeResult.meta.eventLocation;
			}
			return location;
		}
	},
	methods: {
		closePopup() {
			this.$emit('closePopup');
		},
	},
	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
.app-popup {
	position: absolute;
	top: 0;
	left: 0;
	z-index: 1000;
	width: 490px;
	max-width: 100%;
	box-shadow: 0 0 5px rgba($black, 0.15);
	border-radius: 0.5rem;
	&__inner {
		padding: 2rem 2rem 1.5rem 1.5rem;
		background-color: $white;
		border-radius: inherit;
		position: relative;
		z-index: 1000;
	}
	&__close {
		@include clean(button);
		position: absolute;
		width: 1rem;
		height: 1rem;
		display: flex;
		align-items: center;
		justify-content: center;
		top: 0.75rem;
		right: 1rem;
		cursor: pointer;
		i {
			font-size: 0.5rem;
		}
	}
	&__content {
		display: flex;
		flex-direction: column;
		gap: 0.625rem;
	}
	&__type {
		font-size: 0.75rem;
		line-height: 1.25rem;
		text-transform: uppercase;
	}
	&__title,
	&__copy {
		font-size: 1rem;
		line-height: 1.5rem;
	}
	&__title {
		margin-bottom: 0;
		color: $brightBlueAltOrg;
		&-link {
			display: block;
			color: $brightBlueAltOrg;
			text-decoration: none;
			&:hover {
				text-decoration: none;
				color: $blueOrg;
			}
		}
	}
	&__meta {
		display: flex;
		flex-direction: column;
		gap: 0.375rem;
		margin-bottom: 0.625rem;
		&-item {
			display: flex;
			align-items: flex-start;
			gap: 0.75rem;
			font-size: 0.875rem;
			line-height: 1.375rem;
		}
		&-icon {
			width: 1rem;
			min-width: 1rem;
			font-size: 1rem;
			line-height: 1.375rem;
			color: $black;
		}
		&-text {
			font-size: 0.875rem;
			line-height: 1.375rem;
			white-space: pre-wrap;
			color: $black;
		}
	}
	&__copy {
		@include wysiwyg;
	}
	&__pointer {
		position: absolute;
    height: 2rem;
    width: 2rem;
    background: #fff;
    transform: rotate(45deg);
    box-shadow: inherit;
    z-index: 99;
	}
}
</style>